import { DIRECT_PAYMENTS_ROUTE } from '@/router/routes/route-names'

const isObject = (obj) => typeof obj === 'object' && !Array.isArray(obj) && obj !== null

export const setPageTitleFromRoute = (to, from, next) => {
  const { matched: matchedRoutes = [] } = to || {}

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestRouteWithTitle = matchedRoutes
    .slice()
    .reverse()
    .find(route => route.meta?.h1)
  const h1 = nearestRouteWithTitle?.meta?.h1 || ''
  let title = isObject(h1) ? h1?.text : h1

  // If a route with a title was found, set the document (page) title to that value.
  if (title) {
    const isDirectPaymentRoute = matchedRoutes.find(route => route.name === DIRECT_PAYMENTS_ROUTE)
    const mainTitleHeading = isDirectPaymentRoute ? 'Disbursement Link' : 'Reward Link'
    const h2 = !isDirectPaymentRoute ? nearestRouteWithTitle?.meta?.h2 || '' : ''
    const subTitle = isObject(h2) ? h2?.text : h2 // Exclude h2 for Direct Payment routes
    title += (subTitle) ? ` - ${subTitle}` : ''

    document.title = `${mainTitleHeading} | ${title}`
  }

  next()
}
